import React from 'react';

import styles from '../Fields/Fields.module.css';

type CustomTextAreaProps = {
  isInvalid?: boolean;
  rows?: number;
};

export type TextAreaProps = React.DetailedHTMLProps<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
> &
  CustomTextAreaProps;

export function TextArea({
  rows,
  isInvalid,
  ref,
  ...rest
}: TextAreaProps & { ref?: React.Ref<React.ComponentRef<'textarea'>> }) {
  return (
    <textarea
      rows={rows}
      className={styles.textAreaField}
      aria-invalid={isInvalid ? 'true' : 'false'}
      {...rest}
      ref={ref}
    />
  );
}
